import { get, post } from './common'
import { commonUtils } from '../commonUtils'
type ApiBaseResult = ApiTypes.ApiBaseResult

export namespace user {
  export function getLoginUrl(params: {
    utm?: string
    kword?: string
    bdUrl?: string // 包含bd_vid的url
  }): Promise<
    ApiBaseResult & {
      data: {
        scheme: { openlink: string }
        state: string
      }
    }
  > {
    return get('/auth/mnp_oauth2/scheme', {
      // ...params,
    })
  }

  // 确认H5登录状态
  export function confirmH5LoginStatus(state: string): Promise<
    ApiBaseResult & {
      data: {
        login: boolean
      }
    }
  > {
    return get('/auth/mnp_code_login_check', {
      state,
    })
  }
  export function getUserInfo() {
    return get<ApiTypes.DataResult<ServerData.UserData>>('/user/info', {})
  }

  export function getExchangeCode(code: string) {
    return post<ApiTypes.DataResult<unknown> & { version: 'noce' | 'vip' }>(
      '/exchange_code/post',
      {},
      { code }
    )
  }

  export function getLoginQr() {
    return get<ApiTypes.DataResult<ServerData.LoginQrCodeData>>('/auth/register_qr', {})
  }

  export function checkQrLogin(sceneId: string) {
    return get<ApiTypes.DataResult<ServerData.CheckQrLoginData>>('/auth/register_qr/check', {
      sceneId,
    })
  }

  export function postUserActionRecord(data: PostData.UserActionInfo) {
    return post('/user_behavior/burying', {}, data)
  }

  export function loginByWxGzh(
    code: string,
    scope?: 'snsapi_userinfo' | 'snsapi_base'
  ): Promise<
    ApiBaseResult & {
      data: ServerData.UserData
    }
  > {
    return get('/auth/code_login', {
      code,
      scope,
      browserType: commonUtils.isMobile() ? 'mobile' : 'pc',
    })
  }

  export function logout() {
    return get('/user/logout')
  }
}
